"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var Awards_1 = __importDefault(require("./Awards"));
var Infos_1 = __importDefault(require("./Infos"));
var Premium_1 = __importDefault(require("./Premium"));
var style_1 = require("./style");
var MainSection = function (_a) {
    var about = _a.about, awards = _a.awards, contact = _a.contact, premium = _a.premium;
    return (react_1.default.createElement(style_1.Wrapper, null,
        react_1.default.createElement(Infos_1.default, { links: about.links, title: about.title }),
        react_1.default.createElement(Infos_1.default, { links: contact.links, title: contact.title }),
        react_1.default.createElement(Awards_1.default, { awards: awards.awards, title: awards.title }),
        react_1.default.createElement(Premium_1.default, { link: premium.link, sentence: premium.sentence, title: premium.title })));
};
exports.default = MainSection;
